import javadoclike from "refractor/javadoclike";
export default javadoclike;